import { Button } from "@/components/ui/Button";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";

const CallToAction = () => {
    const { t } = useTranslation();
    const { ref, isVisible } = useScrollAnimation();

    return (
        <section
            ref={ref}
            className={`relative py-24 md:py-32 overflow-hidden transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
        >
            <div className="absolute inset-0">
                <img
                    src="/images/worship-hands-raised.jpg"
                    alt=""
                    className="w-full h-full object-cover"
                    loading="lazy"
                    aria-hidden="true"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-foreground/85 via-foreground/75 to-foreground/55" />
            </div>

            <div className="relative max-w-4xl mx-auto px-6 text-center">
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-background mb-6 leading-tight tracking-tight">
                    {t('homepage.cta.title')}
                </h2>
                <p className="text-xl text-background/85 mb-10 leading-relaxed max-w-2xl mx-auto">
                    {t('homepage.cta.description')}
                </p>
                <div className="flex justify-center">
                    <Button
                        asChild
                        size="lg"
                        className="bg-primary hover:bg-primary/90 text-primary-foreground border-none text-base px-8 py-6 rounded-full font-semibold group"
                    >
                        <Link to="/signup-creator">
                            {t('homepage.cta.createProfile')}
                            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                        </Link>
                    </Button>
                </div>
            </div>
        </section>
    );
};

export default CallToAction;
